import { zodNumberLike } from '@dmp/shared/zod-utils';
import { z } from 'zod';

// Constants
// ------------------------------
export const MAX_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE = 25;

// Types
// ------------------------------
export type PaginationOptions = z.output<typeof paginationOptionsSchema>;

// Validation
// ------------------------------
export const paginationOptionsSchema = z
    .object({
        number: zodNumberLike().pipe(z.number().positive()).default(1),
        size: zodNumberLike()
            .pipe(z.number().positive().max(MAX_PAGE_SIZE))
            .default(DEFAULT_PAGE_SIZE),
    })
    .default({ number: 1, size: DEFAULT_PAGE_SIZE });
